import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Скачать историю компании")

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  organizationId: Number,
},
  setup(__props) {

const props = __props


const historyDownloadLink = computed(
  () =>
    `/api/web/admin/organizations/${props.organizationId}/download-info-excel`
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("a", {
    href: _unref(historyDownloadLink),
    download: ""
  }, [
    _createVNode(_component_el_button, {
      type: "primary",
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})